import {createContext, useContext} from "react";

export interface ProductionModuleContextValue {
    id: string;
    label: string;
    isOwner: boolean;
    expired: boolean;
}

const ProductionModuleContext = createContext<ProductionModuleContextValue | null>(null);

/**
 * Module info provided by ProductionModuleGuard to the data tabs it wraps.
 * Returns null when used outside the guard (e.g. the Settings tab, which loads
 * its own module data).
 */
export function useProductionModule(): ProductionModuleContextValue | null {
    return useContext(ProductionModuleContext);
}

export default ProductionModuleContext;
